/**
 * 配置编译环境和线上环境之间的切换
 */
let mina = process.env.mina;
let mkb = process.env.mkb
let sai = process.env.sai
let cust = process.env.cust
let wwwkb = process.env.wwwkb
let txh = process.env.txh;
let qqjy = process.env.qqjy;
let kbao123 = process.env.kbao123;
let mall = process.env.mall;
let imService = "https://kefu.kbao123.com/visitor/mobile/pages/chat/chat.html?bus=300101&orderProductId=&isSendOrder=&appOderType=1&custId="
let uatImService = "https://kefu.kbao123.com/visitor/mobile/pages/chat/chat.html?bus=300101&orderProductId=&isSendOrder=&appOderType=1&custId="

export {
  mina,
  mkb,
  imService,
  sai,
  cust,
  wwwkb,
  txh,
  qqjy,
  kbao123,
  uatImService,
  mall,
};



// WEBPACK FOOTER //
// ./src/config/env.js